import { render, staticRenderFns } from "./card-banner-02-rivoneed.vue?vue&type=template&id=6cb2dd78&scoped=true&"
import script from "./card-banner-02-rivoneed.vue?vue&type=script&lang=js&"
export * from "./card-banner-02-rivoneed.vue?vue&type=script&lang=js&"
import style0 from "./card-banner-02-rivoneed.vue?vue&type=style&index=0&id=6cb2dd78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb2dd78",
  null
  
)

export default component.exports